import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadSubLocation(action) {
  const {
    data: { page, pageSize, orderBy, orderType, accessToken, filter },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/sub-location`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        filter,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.loadSubLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.loadSubLocation.failure())
  }
}

function* createMasterDataSubLocation(action) {
  const {
    data: {
      locations_id,
      name,
      code,
      lat,
      lng,
      description,
      address,
      radius,
      geo_fence,
      accessToken,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/sub-location/create`,
      {
        locations_id,
        name,
        code,
        lat,
        lng,
        description,
        address,
        radius,
        geo_fence,
        matching_name: 'sub-location',
        action_name: 'add',
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    loading(res.data)
    yield put(actions.createMasterDataSubLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.createMasterDataSubLocation.failure())
  }
}

function* updateMasterDataSubLocation(action) {
  const {
    data: {
      id,
      locations_id,
      name,
      code,
      lat,
      lng,
      description,
      address,
      radius,
      geo_fence,
      accessToken,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.put,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/sub-location/edit/${id}`,
      {
        locations_id,
        name,
        code,
        lat,
        lng,
        description,
        address,
        radius,
        geo_fence,
        matching_name: 'sub-location',
        action_name: 'edit',
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    loading(res.data)
    yield put(actions.updateMasterDataSubLocation.success(res.data))
  } catch (err) {
    console.log(err.message)
    yield put(actions.updateMasterDataSubLocation.failure())
  }
}

function* exportSubLocation(action) {
  const {
    data: {
      page,
      pageSize,
      orderBy,
      orderType,
      accessToken,
      filter,
      type,
      file_value_pdf,
      limit_export,
    },
    loading,
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/sub-location`,
      {
        page,
        pageSize,
        orderBy,
        orderType,
        accessToken,
        filter,
        type,
        file_value_pdf,
        limit_export,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.exportSubLocation.success(res.data, page))
    window.location.assign(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download/${res.data.data}`,
    )
  } catch (err) {
    yield put(actions.exportSubLocation.failure())
  }
}

export default function* watchSubLocation() {
  yield all([
    takeEvery(actions.LOAD_MASTERDATA_SUBLOCATION.REQUEST, loadSubLocation),
    takeEvery(
      actions.CREATE_MASTERDATA_SUBLOCATION.REQUEST,
      createMasterDataSubLocation,
    ),
    takeEvery(
      actions.UPDATE_MASTERDATA_SUBLOCATION.REQUEST,
      updateMasterDataSubLocation,
    ),
    takeEvery(
      actions.EXPORT_MASTERDATA_SUBLOCATION.REQUEST,
      exportSubLocation,
    ),
  ])
}

export {
  loadSubLocation,
  createMasterDataSubLocation,
  updateMasterDataSubLocation,
  exportSubLocation,
}
